import React from 'react';
import moment from 'moment';
import { Link } from '@reach/router';
import classNames from 'classnames/bind';
import styles from './index.module.scss';

let cx = classNames.bind(styles);

const JobItem = ({ job }) => {
	return (
		<div className={cx({ jobItem: true, 'flex flex-col': true })} key={job.id}>
			<div
				className={cx({
					jobTitle: true,
					'flex flex-col lg:flex lg:flex-row w-full': true,
				})}
			>
				<div className='flex flex-col flex-1'>
					<strong className='font-Avenir-Black'> {job.name} </strong>
					<small className='font-Avenir-Black'> {job.location}</small>
				</div>
				<div className='flex flex-row lg:flex-col flex-1'>
					<span className='lg:hidden mr-1 font-Avenir-Black'>Fecha de Publicación: </span>
					<strong> {moment(job.start_date).format('DD/MM/YYYY')} </strong>
				</div>
				<div className='flex flex-row lg:flex-col flex-1'>
					<span className='lg:hidden mr-1 font-Avenir-Black'>Fecha de Término: </span>
					<strong> {moment(job.end_date).format('DD/MM/YYYY')} </strong>
				</div>
			</div>
			<div
				className={cx({
					jobButton: true,
					'flex w-full hover:shadow': true,
				})}
			>
				<Link
					className='w-full'
					to={`/ofertas/${job.slug}`}
					rel='noopener noreferrer'
					target='_blank'
				>
					Ver más
				</Link>
			</div>
		</div>
	);
};

export default JobItem;
